export const embedCopy = {
  badge: {
    live: "LIVE",
    offline: "SIARAN OFFLINE",
    auto: "AUTO",
  },
  live: {
    title: "Live Broadcast",
    demoSubtitle: "Demo broadcast",
    tuneIn: "Dengarkan",
    stopListening: "Berhenti mendengarkan",
    connecting: "Menghubungkan…",
  },
  stationPlayer: {
    defaultTitle: "Auto",
  },
  errors: {
    generic: "Terjadi kesalahan. Silakan coba lagi.",
    noLiveBroadcast: "Tidak ada siaran langsung saat ini.",
    missingWebRtc:
      "Siaran aktif tetapi info sesi WebRTC hilang. Di Studio: hentikan siaran, lalu mulai lagi. Untuk dev lokal tanpa Cloudflare Calls, hapus CLOUDFLARE_APP_ID dan CLOUDFLARE_APP_TOKEN dari .dev.vars lalu mulai ulang wrangler (Demo Mode).",
    stationEmpty: "Playlist Auto kosong.",
    missingApiUrl: "Atribut api-url wajib diisi (URL dasar API Radio Ibnul Qoyyim).",
  },
} as const;
